/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.number.constructor.js";
import { useFeedingTable } from '../hooks/useFeedingForm';
export default defineComponent({
  name: 'TableForm',
  props: {
    type: {
      type: Number,
      default: 0
    },
    startTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    }
  },
  setup: function setup(props) {
    var params = ref({
      type: props.type,
      startTime: props.startTime,
      endTime: props.endTime
    });
    var _useFeedingTable = useFeedingTable(params),
      _useFeedingTable2 = _slicedToArray(_useFeedingTable, 2),
      feedingTable = _useFeedingTable2[0],
      getFeedingTableAsync = _useFeedingTable2[1];
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            getFeedingTableAsync();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    var feedingData = computed(function () {
      return feedingTable.value;
    });
    return {
      feedingData: feedingData
    };
  }
});